import { Center, Spinner, HStack, Box } from '@chakra-ui/react';
import { FixedSizeList, ListChildComponentProps } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import InfiniteLoader from 'react-window-infinite-loader';

import MealItemCard from '~/components/MealItemCard';

import { FetchingDataStatus } from '~/types/utilities';
import { ItemCard } from './types';

import { PLATFORM_ID } from '~/globalVariables';

export default function DesktopItemList({
  itemCount,
  items,
  fetchingStatusOfItem,
  onNavigateToItem,
  onLoadNextPage,
  onSetHeaderDisplay,
  onSetItemListRef,
}: {
  items: Array<ItemCard & { disabled?: boolean }>;
  itemCount: number;
  fetchingStatusOfItem: FetchingDataStatus;
  onLoadNextPage: () => void;
  onNavigateToItem: (storeId: string, itemId: string) => void;
  onSetHeaderDisplay: (val: boolean) => void;
  onSetItemListRef: (list: any) => void;
}) {
  const handleIsItemLoaded = (index: number) =>
    itemCount === items.length || index * 2 + 1 < items.length;

  const handleRenderRow = ({
    style,
    index,
  }: React.PropsWithChildren<ListChildComponentProps<any>>) => {
    const leftItem = items?.[index * 2];
    const rightItem = items?.[index * 2 + 1];
    if (!leftItem && !rightItem && fetchingStatusOfItem === FetchingDataStatus.LOADING) {
      return (
        <Center h="135px">
          <Spinner size="lg" />
        </Center>
      );
    }
    return (
      <HStack style={style} spacing={12}>
        {leftItem ? (
          <MealItemCard
            key={`${leftItem.storeId}${leftItem.itemId || leftItem.id || ''}`}
            name={leftItem.name}
            image={leftItem.image}
            price={leftItem.price}
            description={leftItem.description}
            disabled={leftItem?.disabled}
            tags={leftItem.tags[PLATFORM_ID] || []}
            onNavigate={() =>
              onNavigateToItem(leftItem.storeId, leftItem.itemId || leftItem.id || '')
            }
          />
        ) : (
          <Box flex={1}></Box>
        )}
        {rightItem ? (
          <MealItemCard
            key={`${rightItem.storeId}${rightItem.itemId || rightItem.id || ''}`}
            name={rightItem.name}
            image={rightItem.image}
            price={rightItem.price}
            description={rightItem.description}
            disabled={rightItem?.disabled}
            tags={rightItem.tags[PLATFORM_ID] || []}
            onNavigate={() =>
              onNavigateToItem(rightItem.storeId, rightItem.itemId || rightItem.id || '')
            }
          />
        ) : (
          <Box flex={1}></Box>
        )}
      </HStack>
    );
  };

  return (
    <AutoSizer>
      {({ height, width }) => (
        <InfiniteLoader
          isItemLoaded={handleIsItemLoaded}
          itemCount={Math.ceil(itemCount / 2) + 1}
          loadMoreItems={onLoadNextPage}
        >
          {({ onItemsRendered, ref }) => (
            <FixedSizeList
              onScroll={({ scrollOffset }) => onSetHeaderDisplay(scrollOffset ? false : true)}
              itemCount={Math.ceil(itemCount / 2) + 1}
              onItemsRendered={onItemsRendered}
              ref={(list) => {
                onSetItemListRef(list);
                ref(list);
              }}
              height={height}
              width={width}
              itemSize={135}
            >
              {handleRenderRow}
            </FixedSizeList>
          )}
        </InfiniteLoader>
      )}
    </AutoSizer>
  );
}
